import { Source, Layer, useMap } from 'react-map-gl'
import { intersection, isArray, pick, size } from 'lodash-es'
import { useEffect, useMemo } from 'react'

export function RasterLayer({
  sourceId = '',
  tiles = [],
  sourceProps = null,
  layerProps = null,
}) {
  return (
    <Source
      type="raster"
      tiles={tiles}
      tileSize={256}
      {...sourceProps}
      id={sourceId}
    >
      <Layer 
        type="raster"
        {...layerProps}
        source={sourceId}
      />
    </Source>
  )
}

function checkLayerExit(mp, layerId) {
  let isExit = false
  try{ isExit = !!mp.getLayer(layerId) } catch(err) { /**/ }

  return isExit ? mp.getMap() : null
}

function displayLayer(ex, layerId, value) {
  try { ex?.setLayoutProperty?.(layerId, 'visibility', value) } catch(err) { /**/ }
}

/**
 * 内置矢量图层
 */
export function RemoteLayerMapbox({ option }) {
  const { current } = useMap()

  const { layersConfig: lc, source, nextLayerId } = option
  const sourceProps = {
    ...source?.composite, 
    id: lc.source,
    ...pick(lc || {}, ['minzoom', 'maxzoom']) 
  }

  const layerProps = { beforeId: nextLayerId, ...lc }

  const ex = useMemo(() => checkLayerExit(current, lc.id), [current, lc.id])
  
  // 如果图层存在，则设置图层显示
  useEffect(() => {
    displayLayer(ex, lc.id, 'visible')
    return () => { displayLayer(ex, lc.id, 'none') }
  }, [current, ex, lc.id])

  return !ex && (
    <Source {...sourceProps}>
      <Layer {...layerProps} />
    </Source>
  )
}

export function RemoteLayerRaster({ option }) {
  const { layers, nextLayerId, layersConfig: lc } = option
  const sourceProps = { ...pick(lc || {}, ['minzoom', 'maxzoom']) }
  const layerProps = { beforeId: nextLayerId, ...lc }
  
  return (
    <RasterLayer 
      tiles={layers}
      sourceProps={sourceProps}
      layerProps={layerProps}
    />
  )
}

/**
 * 检查是否显示当前图层
 */
export function checkLayerDisplay(extra, locations) {
  const local = isArray(locations) ? locations : []

  return size(extra) > 0 && (
    local.length === 0 || intersection(local, extra?.location).length > 0
  )
}
